import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePlanoContext } from "../contexts/PlanoContext.tsx";
import { getPlanLimits } from "../utils/planLimits.util.ts";

// Gate de conveniência de UI - a autorização de verdade é sempre re-checada
// no backend (PlanoRestritoInterceptor / PlanoService.temPermissao "DASHBOARD").
const EnterpriseRoute = ({ children }: { children: ReactNode }) => {
  const { planoNome, isLoading } = usePlanoContext();

  if (isLoading) return null;

  const { isEnterprise } = getPlanLimits(planoNome);

  if (!isEnterprise) return <Navigate to="/meu-plano" replace />;

  return <>{children}</>;
};

export default EnterpriseRoute;
